import React from "react";
import { useEffect, useState } from "react";
import {
  IconChevronDown,
  IconHome,
  IconInfoHexagon,
  IconMenu2,
  IconNotes,
  IconReceiptDollar,
  IconRecycle,
  IconShieldStar,
  IconFileText,
  IconCrop32,
  IconUser,
  IconRestore,
  IconReceipt,
  IconUserDollar,
  IconUsers,
  IconBrandCodesandbox,
  IconFileTextAi,
  IconMessageChatbot,
  IconChecklist,
} from "@tabler/icons-react";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Header from "./Header";
import { API_ENDPOINTS, NAV_ITEMS } from "../constant/_constant";
import usePostRequest from "../hooks/usePostRequest";
import "./Navbar.css";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { checkPermission } from "../utils/_helpers";

const iconsObj = {
  IconHomeIcon: <IconHome width={22} height={22} />,
  IconFileText: <IconFileText width={22} height={22} />,
  InfoHexagon: <IconInfoHexagon width={22} height={22} />,
  IconReceipt: <IconReceipt width={22} height={22} />,
  IconUserDollar: <IconUserDollar width={22} height={22} />,
  IconUsers: <IconUsers width={22} height={22} />,
  IconBrandCodesandbox: <IconBrandCodesandbox width={22} height={22} />,
  ShieldStar: <IconShieldStar width={22} height={22} />,
  Notes: <IconNotes width={22} height={22} />,
  Recycle: <IconRecycle width={22} height={22} />,
  Customer: <IconUser width={22} height={22} />,
  Product: <IconCrop32 width={22} height={22} />,
  Return: <IconRestore width={22} height={22} />,
  IconFileTextAi: <IconFileTextAi width={22} height={22} />,
  IconMessageChatbot: <IconMessageChatbot width={22} height={22} />,
  IconChecklist: <IconChecklist width={22} height={22} />,
};

const DynamicIcon = ({ iconKey, size, ...props }) => {
  const icon = iconsObj[iconKey];

  if (!icon) {
    return null;
  }

  return React.cloneElement(icon, { size, ...props });
};

const CustomNavbar = ({ isOpen }) => {
  const user = useSelector((state) => state.auth.user);
  console.log("user=>", user);

  const hasPermission = (permissionArray, permissionType) =>
    permissionArray.includes(permissionType);

  /* Badge on "Change Requests": how many are waiting for this user to act. */
  const [awaitingCount, setAwaitingCount] = useState(0);
  const { postData: fetchAwaiting } = usePostRequest(API_ENDPOINTS.CHANGE_REQUEST_LIST);

  useEffect(() => {
    if (!user?.permissions?.manage_orders) {
      return;
    }
    fetchAwaiting({ status: "PENDING", scope: "awaiting_me" }, (res) =>
      setAwaitingCount((res?.data?.items || []).length),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  const userAssignRole = user?.permissions?.manage_role || [];
  const canDeleteUser = hasPermission(userAssignRole, "delete");
  const canAssignRole = hasPermission(userAssignRole, "write");

  return (
    <>
      <Navbar expand="lg" className="bg_nav_dark p-0">
        <Navbar.Toggle className="d-none" aria-controls="navbarScroll">
          <IconMenu2 />
        </Navbar.Toggle>
        <div className="container-xl">
          <Navbar.Collapse id="navbarScroll" in={isOpen}>
            <Nav className="me-auto my-2 my-lg-0" navbarScroll>
              {NAV_ITEMS?.map((navItem) => {
                if (navItem?.title === "home") {
                  return (
                    <Nav.Link
                      className="d-none d-sm-inline-block"
                      key={navItem?.id}
                      as={NavLink}
                      to="/dashboard"
                    >
                      <IconHome /> Home
                    </Nav.Link>
                  );
                }

                if (
                  navItem?.permission &&
                  user?.permissions[navItem?.permission]
                ) {
                  return (
                    <NavDropdown
                      key={navItem?.id}
                      title={
                        <>
                          <DynamicIcon
                            iconKey={navItem?.iconName}
                            style={{ marginRight: "5px" }}
                            size={20}
                          />
                          {navItem?.title}{" "}
                          {navItem?.title === "Change Requests" && awaitingCount > 0 && (
                            <span className="nav_badge_count">{awaitingCount}</span>
                          )}{" "}
                          <IconChevronDown className="icon_down_arrow" />
                        </>
                      }
                    >
                      {/* {navItem?.items?.map((item, index) => {
                        if (
                          hasPermission(
                            user?.permissions[navItem?.permission],
                            item?.action
                          )
                        ) {
                          return (
                            <NavDropdown.Item
                              to={item?.path}
                              key={index}
                              as={NavLink}
                              disabled={item?.disabled}
                            >
                              {item?.name}
                            </NavDropdown.Item>
                          );
                        } else {
                          return null;
                        }
                      })} */}
                      {navItem?.items?.map((item, index) => {
                        if (
                          hasPermission(
                            user?.permissions[navItem?.permission],
                            item?.action,
                          )
                        ) {
                          // External link — open in new tab
                          if (item?.path?.startsWith("http")) {
                            return (
                              <NavDropdown.Item
                                key={index}
                                href={item.path}
                                target="_blank"
                                rel="noopener noreferrer"
                                disabled={item?.disabled}
                              >
                                {item?.name}
                              </NavDropdown.Item>
                            );
                          }

                          return (
                            <NavDropdown.Item
                              to={item?.path}
                              key={index}
                              as={NavLink}
                              disabled={item?.disabled}
                            >
                              {item?.name}
                            </NavDropdown.Item>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </NavDropdown>
                  );
                } else {
                  return null;
                }
              })}
            </Nav>
            {/* <Form className="d-flex">
              <Form.Control
                type="search"
                placeholder="Search..."
                className="custom-search-input"
                aria-label="Search"
              />
            </Form> */}
          </Navbar.Collapse>
        </div>
      </Navbar>
    </>
  );
};

export default CustomNavbar;
